import videojs from "video.js";
import { changeWord } from "./changeWord";
const Component = videojs.getComponent('Component');

export class advertisementLink extends Component {
	createEl() {
		return videojs.dom.createEl('div', {
			className: 'vjs-advertisement-link'
		});
	}
}

export class advertisementMarks extends Component {
	createEl() {
		return videojs.dom.createEl('ul', {
			className: 'advertising-marks'
		});
	}
}

export const initAdvertisement = (player, section) => {
	
	const video = section.querySelector( '.video' );

	if ( !video )
	{
		return;
	}

	const mainVideoSrc = video.dataset.main_src;

	if ( !video.dataset.advertising || !mainVideoSrc ) {
		return;
	}

	let advertising = JSON.parse(video.dataset.advertising);
	let pauseTime = 0;
	const timeRemaining = player.el_.querySelector('.vjs-remaining-time-display');

	const advertisingMarks = document.querySelector('.advertising-marks');
	

	player.on("ended", function() {
		if ( video.classList.contains( 'advertising' ) ) {
			advertising.splice( +video.dataset.adv_index, 1);
			video.classList.remove( 'advertising' );
			video.removeAttribute( 'data-adv_index' );
			player.src({
				src: mainVideoSrc,
				type: 'video/mp4',
				withCredentials: false,
			});
			player.currentTime(pauseTime);
			player.play();
			player.el_.querySelector('.vjs-advertisement-link').remove();
		}
	});	
	
	player.on("timeupdate", function() {
		if ( !video.classList.contains( 'advertising' ) ) {
			advertising.forEach( (adv, index) => {
				if ( Math.round(player.cache_.currentTime) == adv.time  ) {
					pauseTime = adv.time;
					const sourceArray = Object.values(adv.source);
					video.classList.add( 'advertising' );
					video.setAttribute( 'data-adv_index', index )
					player.src({
						src: sourceArray[sourceArray.length - 2],
						type: 'video/mp4',
						withCredentials: false,
					});
					player.play();
					player.addChild('advertisementLink', {text: 'advertisement'});
					player.el_.querySelector('.vjs-advertisement-link').innerHTML = `
						<span data-length="${adv.length}" class="time-remaining">{$adv.length}</span>
						<a href="${adv.link}">Перейти</a>
					`;
				}
			} )
		} else 
		{
			const seconds = +timeRemaining.innerText.split( ':' )[0] * 60 + +timeRemaining.innerText.split( ':' )[1];
			const length = +player.el_.querySelector('.time-remaining').dataset.length;
			player.el_.querySelector('.time-remaining').innerHTML = `${seconds < length ? seconds : length} ${changeWord('секунд', 'секунда', 'секунды', seconds < length ? seconds : length)}`;
		}
	});	
	if ( advertisingMarks ) {
		const seekBar = player.getChild('ControlBar').getChild('ProgressControl').getChild('SeekBar')
		seekBar.addChild('advertisementMarks');
		seekBar.getChild('advertisementMarks').el_.innerHTML = advertisingMarks.innerHTML;
		player.one('loadedmetadata', () => {
			seekBar.getChild('advertisementMarks').el_.children.forEach( item => {
				item.style.left = item.dataset.time / player.duration() * 100 + '%';
			});
		})
	}
}